import api from 'api';

export const Types = {
  GET_GRUPOS: 'estados/GET_GRUPOS',
  GET_GRUPOS_SUCCESS: 'estados/GET_GRUPOS_SUCCESS',
  GET_GRUPOS_FAILED: 'estados/GET_GRUPOS_FAILED',
  UPDATE_GRUPO: 'estados/UPDATE_GRUPO',
  UPDATE_GRUPO_SUCCESS: 'estados/UPDATE_GRUPO_SUCCESS',
  UPDATE_GRUPO_FAILED: 'estados/UPDATE_GRUPO_FAILED',
  DELETE_GRUPO: 'estados/DELETE_GRUPO',
  DELETE_GRUPO_SUCCESS: 'estados/DELETE_GRUPO_SUCCESS',
  DELETE_GRUPO_FAILED: 'estados/DELETE_GRUPO_FAILED',
};

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export default function estadosReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_GRUPOS:
      return { ...state, loading: true };
    case Types.GET_GRUPOS_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.GET_GRUPOS_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.UPDATE_GRUPO:
      return { ...state, loading: true };
    case Types.UPDATE_GRUPO_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.UPDATE_GRUPO_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.DELETE_GRUPO:
      return { ...state, loading: true };
    case Types.DELETE_GRUPO_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.DELETE_GRUPO_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  getGrupos: () => async dispatch => {
    try {
      dispatch({ type: Types.GET_GRUPOS });
      const grupos = await api.get('/roles');
      dispatch({ type: Types.GET_GRUPOS_SUCCESS, payload: { data: grupos.data } });
    } catch (woof) {
      dispatch({
        type: Types.GET_GRUPOS_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
  createGrupo: group => async (dispatch, store) => {
    try {
      dispatch({ type: Types.UPDATE_GRUPO });
      const updatedGrupo = await api.post('/roles', {
        ...group,
        permissions: group.permissions.map(p => p.id),
      });
      const updatedGroups = store().grupos.data.concat(updatedGrupo.data);
      dispatch({
        type: Types.UPDATE_GRUPO_SUCCESS,
        payload: { data: updatedGroups },
      });
    } catch (e) {
      dispatch({
        type: Types.UPDATE_GRUPO_FAILED,
        payload: { error: e.message },
      });
    }
  },
  updateGrupo: group => async (dispatch, store) => {
    try {
      dispatch({ type: Types.UPDATE_GRUPO });
      const updatedGrupo = await api.put(`/roles/${group.id}`, {
        ...group,
        permissions: group.permissions.map(p => p.id),
      });
      const updatedGroups = store().grupos.data.map(g =>
        g.id !== group.id ? g : updatedGrupo.data,
      );
      dispatch({
        type: Types.UPDATE_GRUPO_SUCCESS,
        payload: { data: updatedGroups },
      });
    } catch (e) {
      dispatch({
        type: Types.UPDATE_GRUPO_FAILED,
        payload: { error: e.message },
      });
    }
  },
  deleteGrupo: group => async (dispatch, store) => {
    try {
      dispatch({ type: Types.DELETE_GRUPO });
      await api.delete(`/roles/${group.id}`);
      const updatedGroups = store().grupos.data.filter(g =>
        g.id !== group.id,
      );
      dispatch({
        type: Types.DELETE_GRUPO_SUCCESS,
        payload: { data: updatedGroups },
      });
    } catch (e) {
      dispatch({
        type: Types.DELETE_GRUPO_FAILED,
        payload: { error: e.message },
      });
    }
  },
};
